import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { jobTrendRankingSelector } from '@doda/common/src/redux/features/JobContent/JobTrend/jobTrendRanking';
import { formatDate } from '../../../logics/JobContent/createFormatDate';
import { convertQueryToURI } from '../../../logics/JobContent/convertQueryToURI';
import { useAppSelector } from '../../../redux/hooks';

interface Props {
  targetName: string;
}

/**
 * 求人トレンドページ用のSEO対策metaタグ作成hooks
 * @param targetName ページの一軸名
 * @returns 整形したSEO情報（title, description, keywords, canonicalUrl ）
 */
export const useMetaData = ({ targetName }: Props) => {
  const queryParams = useAppSelector(appQueryParamsSelector);
  const jobRanking = useAppSelector(jobTrendRankingSelector);
  const publicationDate = formatDate(jobRanking.publicationDate, false);

  const incomeList = jobRanking.income;
  const employeeAverageAgeList = jobRanking.employeeAverageAge;
  const establishList = jobRanking.establish;
  if (
    incomeList.length < 1 ||
    employeeAverageAgeList.length < 1 ||
    establishList.length < 1
  ) {
    return { title: '', description: '', keywords: '', canonicalUrl: '' };
  }
  // 年収
  const combinedArrayIncome = incomeList[0].map((item, index) => [
    item,
    incomeList[1][index],
  ]);
  combinedArrayIncome.sort((a, b) => Number(b[0]) - Number(a[0]));
  const incomeNo1 = combinedArrayIncome[0][1];

  // 平均年齢
  const combinedArrayEmployeeAverageAgeList = employeeAverageAgeList[0].map(
    (item, index) => [item, employeeAverageAgeList[1][index]]
  );
  combinedArrayEmployeeAverageAgeList.sort(
    (a, b) => Number(b[0]) - Number(a[0])
  );
  const employeeAverageAgeNo1 = combinedArrayEmployeeAverageAgeList[0][1];

  // 設立
  const combinedArrayEstablish = establishList[0].map((item, index) => [
    item,
    establishList[1][index],
  ]);
  combinedArrayEstablish.sort((a, b) => Number(b[0]) - Number(a[0]));
  const establishNo1 = combinedArrayEstablish[0][1];

  const title = `${targetName} doda掲載中求人の傾向│doda（デューダ）${publicationDate}更新`;

  const description = `${targetName}で募集している求人の傾向をご紹介。${targetName}では「${jobRanking.requirements[1][0]}」や「${incomeNo1}」の求人が多い傾向です。dodaに掲載している求人に関するデータを、エリア、職種、業種、条件別でお届け。転職市場のリアルが分かる。`;

  const keywords = `${targetName},${jobRanking.requirements[1][0]},${incomeNo1},${jobRanking.workplaceEnvironment[1][0]},${jobRanking.holidayAndWayOfWorking[1][0]},社員の平均年齢${employeeAverageAgeNo1},${jobRanking.employmentStatus[1][0]},${jobRanking.welfareBenefits[1][0]},${jobRanking.positionsAndLanguageSkills[1][0]},設立${establishNo1},求人,求人数,求人情報,転職,doda`;

  const canonicalUrl = makeStaticUrl(
    convertQueryToURI(queryParams),
    DODA_SITE_URL.jobTrend
  );

  return { title, description, keywords, canonicalUrl };
};
